import React, { Component } from 'react';
import { Skeleton } from 'primereact/skeleton';

class CustomSkeleton extends Component {
  public render() {
    return (
      <div className='flex h-full w-full gap-2 flex-col' data-testid={`custom-skeleton`}>
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
        <Skeleton width='100%' height='50px' />
      </div>
    );
  }
}

export default CustomSkeleton;
